import { render, staticRenderFns } from "./InvoiceDetailsTable.vue?vue&type=template&id=b0ee3f32&"
import script from "./InvoiceDetailsTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsTable.vue?vue&type=style&index=0&id=b0ee3f32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports